import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicab() {



    const cardData = {

keyword: "Pune to Shirdi Cab",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Shirdi Cab services for families, devotees, and pilgrims visiting Sai Baba’s holy shrine. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth and peaceful journey. Our service includes doorstep pickup from Pune, flexible one-way and round-trip options, 24/7 booking support, and transparent pricing, ensuring a hassle-free spiritual travel experience to Shirdi.",

topPlaces: [
    {
        title: "Shri Sai Baba Samadhi Mandir",
        description:
            "Shri Sai Baba Samadhi Mandir is the most sacred place in Shirdi, where devotees from all over the world come to seek blessings of Sai Baba. The temple houses the Samadhi of Sai Baba and is known for its peaceful spiritual atmosphere, continuous chanting, and well-organized darshan system."
    },
    {
        title: "Dwarkamai Mosque",
        description:
            "Dwarkamai Mosque is where Sai Baba lived for most of his life and performed many miracles. The site holds deep spiritual importance and contains sacred artifacts like the stone where Baba used to sit and the eternal sacred fire (dhuni) that still burns today."
    },
    {
        title: "Chavadi",
        description:
            "Chavadi is a historic place associated with Sai Baba’s nightly resting rituals. It is preserved as a memorial and reflects the simplicity and divine life of Sai Baba during his stay in Shirdi."
    },
    {
        title: "Shani Shingnapur",
        description:
            "Shani Shingnapur is a famous temple village near Shirdi dedicated to Lord Shani. It is unique for its open-air deity shrine and strong belief in divine justice and protection, attracting thousands of devotees daily."
    },
    {
        title: "Sai Heritage Village",
        description:
            "Sai Heritage Village is a cultural theme park in Shirdi showcasing the life and times of Sai Baba through exhibits, statues, and traditional setups that help visitors understand his teachings and legacy."
    },
    {
        title: "Wet N Joy Water Park",
        description:
            "Wet N Joy Water Park is a popular amusement destination near Shirdi offering water slides, wave pools, and family-friendly rides, making it a fun spot for pilgrims and tourists after darshan."
    },
    {
        title: "Khandoba Mandir",
        description:
            "Khandoba Mandir is one of the first places where Sai Baba was welcomed in Shirdi. The temple holds historical importance and is closely linked to Baba’s arrival in the village."
    },
    {
        title: "Lendi Baug",
        description:
            "Lendi Baug is a peaceful garden maintained by Sai Baba himself, where he used to water plants and meditate. It is a calm and spiritual place for reflection and devotion."
    },
    {
        title: "Shirdi Museum",
        description:
            "Shirdi Museum displays photographs, personal belongings, and artifacts related to Sai Baba’s life, giving devotees a deeper understanding of his teachings and miracles."
    },
    {
        title: "Sai Teerth Theme Park",
        description:
            "Sai Teerth Theme Park is India’s first devotional theme park dedicated to Sai Baba, featuring 4D experiences, rides, and spiritual storytelling for devotees and tourists."
    }
],



services: [
{
name: "Pune to Shirdi Cab Service",
description: "Rising Cab Service offers Pune to Shirdi Cab Service for a safe, comfortable, and reliable pilgrimage journey to Shri Sai Baba Samadhi Mandir. Enjoy well-maintained AC Sedan, SUV, Innova Crysta, Kia Carens, and Tempo Traveller options with experienced drivers, doorstep pickup from Pune, and flexible one-way or round-trip travel for families, groups, and devotees."
},
{
name: "Pune to Shirdi Taxi Service",
description: "Book Pune to Shirdi Taxi Service with Rising Cab Service for a smooth and stress-free spiritual journey. We provide clean vehicles, professional chauffeurs, transparent pricing, and 24x7 booking support for a comfortable Sai Baba darshan trip."
},
{
name: "Pune to Shirdi Cab Booking",
description: "Our Pune to Shirdi Cab Booking service ensures quick reservation, instant confirmation, and multiple vehicle options. Plan your pilgrimage easily with reliable service, flexible timings, and doorstep pickup from anywhere in Pune."
},
{
name: "Pune to Shirdi One Way Cab",
description: "Book Pune to Shirdi One Way Cab for affordable drop-only travel with safe driving and comfortable AC vehicles. Ideal for solo pilgrims, families, and devotees traveling for Sai Baba darshan."
},
{
name: "Pune to Shirdi Round Trip Taxi",
description: "Our Pune to Shirdi Round Trip Taxi service is perfect for same-day or overnight return journeys with waiting facility, flexible schedules, and comfortable travel options for families and groups."
},
{
name: "Cheap Pune to Shirdi Cab",
description: "Rising Cab Service provides Cheap Pune to Shirdi Cab options without compromising safety and comfort. Enjoy budget-friendly travel with verified drivers, clean cars, and transparent fares."
},
{
name: "Best Pune to Shirdi Taxi",
description: "Our Best Pune to Shirdi Taxi service ensures reliable, safe, and comfortable travel experience with professional drivers and well-maintained vehicles for a peaceful pilgrimage."
},
{
name: "Sedan Pune to Shirdi Cab",
description: "Book Sedan Pune to Shirdi Cab for economical and comfortable travel for small families and couples with AC comfort, clean interiors, and smooth highway driving."
},
{
name: "SUV Pune to Shirdi Taxi",
description: "Rising Cab Service offers SUV Pune to Shirdi Taxi for group travel with spacious seating, extra luggage space, and powerful highway performance for a comfortable journey."
},
{
name: "Innova Pune to Shirdi Cab",
description: "Book Innova Pune to Shirdi Cab for premium comfort, spacious seating, and smooth long-distance travel ideal for families and group pilgrimages to Sai Baba temple."
},
{
name: "Shirdi Darshan Cab Pune",
description: "Our Shirdi Darshan Cab Pune service provides complete pilgrimage support with safe travel, flexible stops, and comfortable vehicles for a peaceful Sai Baba temple visit."
}
],

tableData: [
["Pune to Shirdi Cab Service","Pune to Shirdi Taxi Service"],
["Pune to Shirdi Cab Booking","Pune to Shirdi One Way Cab"],
["Pune to Shirdi Round Trip Taxi","Cheap Pune to Shirdi Cab"],
["Best Pune to Shirdi Taxi","Sedan Pune to Shirdi Cab"],
["SUV Pune to Shirdi Taxi","Innova Pune to Shirdi Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Shirdi Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Shirdi cab transportation for Sai Baba devotees, families, senior citizens, tourists, and pilgrimage groups."
    },
    {
        WhyChooseheading: "Convenient Sai Baba Darshan Travel",
        WhyChoosedescription: "Travel peacefully to Shirdi Sai Baba Temple with dedicated cab services designed for comfortable religious and spiritual journeys."
    },
    {
        WhyChooseheading: "Ideal for Same-Day and Multi-Day Trips",
        WhyChoosedescription: "Whether planning a same-day Shirdi Darshan, overnight stay, weekend pilgrimage, or family tour, we offer flexible travel options."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Choices",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your group size and travel needs."
    },
    {
        WhyChooseheading: "Cover Nearby Religious Destinations",
        WhyChoosedescription: "Travelers can combine Shirdi Darshan with visits to Shani Shingnapur, Trimbakeshwar, Nashik, Grishneshwar, and other spiritual destinations."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Comfortable Travel for Families and Senior Citizens",
        WhyChoosedescription: "Our spacious vehicles and professional drivers make the pilgrimage comfortable for devotees of all age groups."
    },
    {
        WhyChooseheading: "Trusted Choice for Religious Tours",
        WhyChoosedescription: "Rising Cab Service is preferred by devotees seeking safe transportation, punctual service, and hassle-free travel arrangements."
    }
]
};

const faqData = [
    {
        question: "Why is Shirdi one of Maharashtra's most visited pilgrimage destinations?",
        answer: "Shirdi is the sacred place associated with Sai Baba and attracts millions of devotees every year from across India and abroad."
    },
    {
        question: "Can I book a one-way cab from Pune to Shirdi?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which places can be visited along with Shirdi Darshan?",
        answer: "Popular nearby destinations include Shani Shingnapur, Nashik, Trimbakeshwar Temple, Saptashrungi Devi Temple, and Grishneshwar Jyotirlinga."
    },
    {
        question: "Which vehicle is best for a family trip to Shirdi?",
        answer: "Ertiga and Innova Crysta are among the most preferred vehicles because they offer comfortable seating and sufficient luggage space."
    },
    {
        question: "Are Tempo Travellers available for group pilgrimages?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family groups, corporate groups, and religious tours."
    },
    {
        question: "Can same-day Shirdi Darshan trips be arranged?",
        answer: "Yes, many devotees choose same-day return packages for convenient Sai Baba Darshan."
    },
    {
        question: "Is advance booking recommended during weekends and festivals?",
        answer: "Yes, advance reservations are recommended during weekends, public holidays, Guru Purnima, Ram Navami, and festive seasons."
    },
    {
        question: "Can Shani Shingnapur be included in the itinerary?",
        answer: "Yes, Shani Shingnapur is one of the most commonly included destinations in Pune to Shirdi pilgrimage packages."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I reserve a Pune to Shirdi Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sandeep Kshirsagar",
        feedback:
            "Our Sai Baba Darshan trip was planned beautifully. The vehicle arrived on time, the journey was comfortable, and we completed the pilgrimage without any travel stress.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali More",
        feedback:
            "Traveling with elderly family members to Shirdi became very convenient. The cab was spacious, the driver was polite, and the overall experience was excellent.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Shirdi Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-shirdi-cab.jpg",
"description": "Book Pune to Shirdi Cab Service with Rising Cab Service for safe, comfortable, and spiritual travel to Sai Baba Temple. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family darshan trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-shirdi-cab"
}
};





    return (
        <div>
<Helmet>
  <title>Pune to Shirdi Cab | Sai Baba Darshan Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Shirdi Cab Service for safe and comfortable Sai Baba darshan travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to shirdi cab, pune to shirdi taxi, cab from pune to shirdi, taxi from pune to shirdi, pune to shirdi cab service, pune to shirdi taxi fare, pune to shirdi one way cab, pune to shirdi round trip taxi, pune to shirdi cab booking, cheap pune to shirdi cab, best pune to shirdi taxi, sedan pune to shirdi cab, suv pune to shirdi taxi, innova pune to shirdi cab, shirdi darshan cab pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdicab;